package ui.widget

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.graphics.*
import androidx.compose.ui.unit.*
import com.godaddy.android.colorpicker.*
import org.jetbrains.compose.resources.*


import ssoft.frontend.generated.resources.*
import tools.*


@Composable
fun ColorPicker(
    state: DialogState,
    field: EFieldColorAsLong,
    label: StringResource,
    onPick: (Color) -> Unit
) {

    val lastColor = remember(field.state) {
        mutableStateOf(HsvColor.from(field.state))
    }


    Dialog(
        state = state,
        onDismiss = { state.hide() }
    ) {
        DialogUI(
            modifier = Modifier.align(Alignment.Center),
            onDismissRequest = { state.hide() },
            title = { Text(label.rememberString()) },
            confirmButton = {
                OutlinedButton(
                    onClick = {
                        state.hide()
                        onPick(lastColor.value.toColor())
                    }
                ) {
                    Text(Res.string.dialog__action_ok.rememberString())
                }
            },
            dismissButton = {
                OutlinedButton(
                    onClick = { state.hide() },
                ) {
                    Text(Res.string.dialog__action_cancel.rememberString())
                }
            }
        ) {
            Column(Modifier.align(Alignment.Center)) {
                ClassicColorPicker(
                    modifier = Modifier.size(300.dp),
                    color = lastColor.value,
                    showAlphaBar = true,
                    onColorChanged = { color: HsvColor ->
                        lastColor.value = color
                    }
                )
            }
        }
    }
}
